import type { BrowserConfig } from '@bugsnag/js';
import SENSITIVE_FIELD_NAMES from 'settings/sensitive-field-names';

/**
 * Metadata keys that must never leave Creator in BugSnag error events.
 *
 * Supplying this option replaces BugSnag's password-only default, so that
 * default is included alongside Creator's authentication and integration
 * credential shapes.
 */
export const BUGSNAG_REDACTED_KEYS = [
	...Object.values(SENSITIVE_FIELD_NAMES),
	/email/i,
	/password/i,
	/authorization/i,
	/cookie/i,
	/secret/i,
	/token/i,
	/access[_-]?code/i,
	/api[_-]?key/i,
] satisfies NonNullable<BrowserConfig['redactedKeys']>;
